"use client";

import React, { useState } from "react";

import { useTranslation } from "~/app/hooks/useTranslation";
import hero4 from "~/assets/images/announcement/hero4.svg?url";
import HeroCarousel from "~/common/components/HeroCarousel";
import SectionWrapper from "~/common/components/SectionWrapper";
import TestimonialCard from "~/common/components/TestimonialCard";
import { getTestimonials } from "~/common/data/testimonials";

import styles from "./AnnouncementsSection4.module.scss";
export default function AnnouncementsSection4() {
  const { t } = useTranslation();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const testimonials = getTestimonials(t);

  return (
    <SectionWrapper background={hero4} className={styles.section}>
      <HeroCarousel selectedIndex={selectedIndex} onSlideChange={setSelectedIndex}>
        {testimonials.map((t) => (
          <TestimonialCard key={t.id} {...t} />
        ))}
      </HeroCarousel>
    </SectionWrapper>
  );
}
